import { Link } from 'react-router-dom';
import type { ChatToken } from '../../lib/types';

/**
 * Renders a message from the tokens the server parsed.
 *
 * Every branch produces a React element. Nothing here touches
 * `dangerouslySetInnerHTML`, and the server already refused to build a link
 * token for anything but an internal path — so a chat message cannot become a
 * script, and cannot become a one-click trip to somewhere off the site.
 */
export function ChatMessageBody({ tokens }: { tokens: ChatToken[] }) {
  return (
    <>
      {tokens.map((token, index) => {
        const key = `${token.kind}-${index}`;
        switch (token.kind) {
          case 'bold':
            return <strong key={key}>{token.text}</strong>;
          case 'italic':
            return <em key={key}>{token.text}</em>;
          case 'strike':
            return <s key={key}>{token.text}</s>;
          case 'code':
            return (
              <code key={key} className="chat__code">
                {token.text}
              </code>
            );
          case 'mention':
            return (
              <Link key={key} className="chat__mention" to={`/trainer/${token.username}`}>
                {token.text}
              </Link>
            );
          case 'link':
            return (
              <Link key={key} className="chat__link" to={token.href}>
                {token.text}
              </Link>
            );
          case 'emoji':
            return (
              <span key={key} className="chat__emoji" role="img" aria-label={token.name}>
                {token.text}
              </span>
            );
          default:
            return <span key={key}>{token.text}</span>;
        }
      })}
    </>
  );
}
